import { render, staticRenderFns } from "./EconomicCalendar.vue?vue&type=template&id=01969124&scoped=true"
import script from "./EconomicCalendar.vue?vue&type=script&lang=js"
export * from "./EconomicCalendar.vue?vue&type=script&lang=js"
import style0 from "./EconomicCalendar.vue?vue&type=style&index=0&id=01969124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01969124",
  null
  
)

export default component.exports